function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.51 27L2.1 13.91a8.6 8.6 0 01.41-11.7 7.56 7.56 0 0111.09.44 1.52 1.52 0 001.77 0 7.56 7.56 0 0111.09-.44 8.61 8.61 0 01.44 11.67L14.51 27",
  fill: "#333",
  "data-name": "Layer 1-2"
})));

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 27"
  }, props), _ref);
}

export default SvgHeart;